import { ActionTypes } from "@/App/constants/actionTypes";
import { ClaimTypes } from "@/types";

type UserSearchForClaimsAction = {
  type: typeof ActionTypes.SEARCH_FOR_CLAIM;
  payload: ClaimTypes.ClaimSearchOptions;
  formName?: string;
};

export const userSearchForClaims = (data: { data: ClaimTypes.ClaimSearchOptions; formName?: string }): UserSearchForClaimsAction => {
  return {
    type: ActionTypes.SEARCH_FOR_CLAIM,
    payload: data.data,
    formName: data.formName,
  };
};

type UserSearchForClaimsResultsAction = {
  type: typeof ActionTypes.SEARCH_FOR_CLAIM_RESULTS;
  payload: ClaimTypes.ClaimSearchResults;
};

export const userSearchForClaimsResults = (data: ClaimTypes.ClaimSearchResults): UserSearchForClaimsResultsAction => {
  return {
    type: ActionTypes.SEARCH_FOR_CLAIM_RESULTS,
    payload: data,
  };
};

type UserGetClaimAction = {
  type: typeof ActionTypes.GET_CLAIM;
  payload: { id: string };
};

export const userGetClaim = (id: string): UserGetClaimAction => {
  return {
    type: ActionTypes.GET_CLAIM,
    payload: { id },
  };
};

type UserGetClaimResultsAction = {
  type: typeof ActionTypes.GET_CLAIM_RESULTS;
  payload: ClaimTypes.Claim;
};

export const userGetClaimResults = (data: ClaimTypes.Claim): UserGetClaimResultsAction => {
  return {
    type: ActionTypes.GET_CLAIM_RESULTS,
    payload: data,
  };
};

export type ClaimSearchAction =
  | UserSearchForClaimsAction
  | UserSearchForClaimsResultsAction
  | UserGetClaimAction
  | UserGetClaimResultsAction;
